import { useAtomValue } from "jotai";
import {
  type OrderGetOrderDetailsReadDto,
  type OrderItemDetailsOrderReadDto,
} from "@/config/apiClient";
import { userAtom } from "@/store";
import { useRolePermission } from "../rolePermission/useRolePermission";

// Hook to check if the user can edit the order. If it's and advertiser, check if the user is the owner of the order.
export const useUserCanEditOrder = (
  order: OrderGetOrderDetailsReadDto | OrderItemDetailsOrderReadDto | undefined
) => {
  const currentUser = useAtomValue(userAtom);
  const { hasAdvertiserRole } = useRolePermission();

  if (!currentUser?.id || !order) {
    return false;
  }
  if (!hasAdvertiserRole) {
    return true;
  }

  return (
    order.OrdersToUsers?.some(({ userId }) => userId === currentUser.id) ??
    false
  );
};
